export const tool = [
  {
    data: `Row`,
    title: "Column",
    name: "Row / Column",
    label: "",
    edit: false,
    columnLayout: 1,
    rowStyle: {
      rowBg: "",
      croppedBg: "",
      backgroundRepeat: "no-repeat",
      rowBgColor: { r: 255, g: 255, b: 255, a: 1 },
      paddingUnit: "px",
      paddingTop: "50",
      paddingBottom: "50",
      paddingTopMobile: "30",
      paddingBottomMobile: "30",
      opacity: 1,
    },
    columnsBG: {
      c1: {
        bgImage: "",
        bgColor: "transparent",
        bgRepeat: "no-repeat",
        borderWidth: "0",
        borderColor: { r: 255, g: 255, b: 255, a: 0 },
        bgSize: "auto",
        gutterSpaceUnit: "px",
        gutterSpace: "0", // for old data
        gutterSpaceLeft: "0",
        gutterSpaceRight: "0",
        gutterSpaceMobile: "0", // for old data
        gutterSpaceMobileLeft: "0",
        gutterSpaceMobileRight: "0",
        gutterSpaceTopBottom: "0", // for old data
        gutterSpaceTopBottom_T: "0",
        gutterSpaceTopBottom_B: "0",
        gutterSpaceTopBottomMobile: "0", // for old data
        gutterSpaceTopBottomMobileTop: "0",
        gutterSpaceTopBottomMobileBottom: "0",
      },
      c2: {
        bgImage: "",
        bgColor: "transparent",
        bgRepeat: "no-repeat",
        borderWidth: "0",
        borderColor: { r: 255, g: 255, b: 255, a: 0 },
        bgSize: "auto",
        gutterSpaceUnit: "px",
        gutterSpace: "0", //old
        gutterSpaceLeft: "0",
        gutterSpaceRight: "0",
        gutterSpaceMobile: "0", // old
        gutterSpaceMobileLeft: "0",
        gutterSpaceMobileRight: "0",
        gutterSpaceTopBottom: "0", //old
        gutterSpaceTopBottom_T: "0",
        gutterSpaceTopBottom_B: "0",
        gutterSpaceTopBottomMobile: "0", // old
        gutterSpaceTopBottomMobileTop: "0",
        gutterSpaceTopBottomMobileBottom: "0",
      },
    },
    deskWidth: [50, 50],
    tabWidth: [50, 50],
    mobWidth: [50, 50],
    columns: {
      c1: [],
      c2: [],
    },
  },
  {
    data: `Accordion`,
    title: "Accordion",
    name: "Accordion",
    label: "Accordion",
    accordion: {
      widthUnit: "%",
      marginUnit: "px",

      desktopStyle: {
        alignment: "left",
        borderColor: { r: 12, g: 50, b: 84, a: 1 },
        borderWidth: 1,
        borderRadius: 0,
        marginTop: 0,
        marginBottom: 0,
        width: 100,
        multiItemExpand: false,
        iconType: "arrow",
      },
      mobileStyle: {
        alignment: "left",
        borderColor: { r: 12, g: 50, b: 84, a: 1 },
        borderWidth: 1,
        borderRadius: 0,
        marginTop: 0,
        marginBottom: 0,
        width: 100,
        multiItemExpand: false,
        iconType: "arrow",
      },
    },
    columnSettings: {
      c1: {
        itemHeader: {
          title: "Accordion Item 1",
          paddingUnit: "px",
          desktopStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
          mobileStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
        itemBody: {
          paddingUnit: "px",
          desktopStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 50,
            paddingBottom: 50,
          },
          mobileStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 20,
            paddingBottom: 20,
          },
        },
      },
      c2: {
        itemHeader: {
          title: "Accordion Item 2",
          paddingUnit: "px",
          desktopStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
          mobileStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
        itemBody: {
          paddingUnit: "px",
          desktopStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 50,
            paddingBottom: 50,
          },
          mobileStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 20,
            paddingBottom: 20,
          },
        },
      },
      c3: {
        itemHeader: {
          title: "Accordion Item 3",
          paddingUnit: "px",
          desktopStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
          mobileStyle: {
            color: { r: 12, g: 50, b: 84, a: 100 },
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            expandedBackgroundColor: { r: 213, g: 219, b: 226, a: 100 },
            iconColor: { r: 255, g: 143, b: 84, a: 60 },
            fontFamily: "Montserrat",
            fontSize: 12,
            fontBold: false,
            borderColor: { r: 12, g: 50, b: 84, a: 100 },
            borderRadius: 0,
            borderWidth: 1,
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
        itemBody: {
          paddingUnit: "px",
          desktopStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 50,
            paddingRight: 50,
            paddingTop: 50,
            paddingBottom: 50,
          },
          mobileStyle: {
            backgroundColor: { r: 252, g: 252, b: 252, a: 100 },
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 20,
            paddingBottom: 20,
          },
        },
      },
    },
    columns: {
      c1: [],
      c2: [],
      c3: [],
    },
  },

  {
    data: `BUTTON`,
    title: "Button",
    name: "Button",
    label: "",
    customElementName: null,
    language: "ENG",
    link: "",
    linkname: "",
    linktype: "",
    linkopen: "_blank",
    use_social: false,
    content: "Add Label",
    edit: false,

    buttonURL: "",
    mobileAlignment: "center",
    style: {
      btnPaddingUnit: "px",
      btnMarginUnit: "px",
      paddingTop: "10",
      paddingRight: "20",
      paddingBottom: "10",
      paddingLeft: "20",
      marginTop: "0",
      marginRight: "0",
      marginBottom: "0",
      marginLeft: "0",
      fontFamily: "",
      fontSize: "16",
      fontWeight: "normal",
      borderWidth: "1",
      borderRadius: "50",
      backgroundColor: "",
      float: "left",
      width: "auto",
    },
    normalBtn: {
      txtColor: {
        hex: "#ffffff",
        rgb: { r: 255, g: 255, b: 255, a: 1 },
      },
      btnBG: {
        hex: "#0c3254",
        rgb: { r: 12, g: 50, b: 84, a: 1 },
      },
      btnBorder: {
        hex: "#0c3254",
        rgb: { r: 12, g: 50, b: 84, a: 1 },
      },
    },
    hoverBtn: {
      txtColor: {
        hex: "#ffffff",
        rgb: { r: 255, g: 255, b: 255, a: 1 },
      },
      btnBg: {
        hex: "#0062cc",
        rgb: { r: 0, g: 98, b: 204, a: 1 },
      },
      btnBorder: {
        hex: "#0c3254",
        rgb: { r: 12, g: 50, b: 84, a: 1 },
      },
    },
  },

  {
    data: `TEXT`,
    name: "Text",
    title: "Text",
    label: "",
    text: "This is text content. Edit here...",
    edit: false,
    desktopStyle: {},
    mobileStyle: {},
    style: {},
    maxWidth: "2000px",
    marginLeft: "0px",
  },

  {
    data: `FORM`,
    name: "Form",
    title: "Form",
    label: "",
    email: "",
    identifier: "",
    // width:'',
    style: {
      width: "0",
      borderWidth: "0",
      backgroundColor: "#ffffff",
      borderColor: { r: 255, g: 255, b: 255, a: 1 },
      color: "#000000",
      float: "left",
      borderStyle: "solid",
      fontFamily: "",
      borderRadius: "0",
    },
    fields: [
      {
        data: "input",
        type: "text",
        placeholder: "Enter name",
        label: "Name",
        required: false,
      },
      {
        data: "input",
        type: "email",
        placeholder: "Enter e-mail",
        label: "E-mail",
        required: false,
      },
      {
        data: "submit",
        type: "submit",
        label: "Submit",
        normalBtn: {
          txtColor: "#fff",
          btnBg: "#000",
          btnBorder: "#ccc",
        },
        hoverBtn: {
          txtColor: "#fff",
          btnBg: "#000",
          btnBorder: "#ccc",
        },
        style: {
          paddingTop: "8",
          paddingRight: "20",
          paddingBottom: "8",
          paddingLeft: "20",
          fontFamily: "inherit",
          fontSize: "16",
          borderWidth: "1",
          borderRadius: "5",
          float: "left",
          borderStyle: "solid",
        },
      },
    ],
  },
  {
    data: `IMAGE`,
    name: "Image",
    title: "Image",
    label: "",
    link: "",
    linkname: "",
    linktype: "",
    linkopen: "_blank",
    use_social: false,
    edit: false,
    addImage: false,
    srcID: null,
    src: null,
    href: "",
    style: {
      maxWidth: "auto",
      height: "auto",
      opacity: "1",
      borderRadius: "0",
      float: "none",
      imageWidthUnit: "px",
    },
  },
  {
    data: `VIDEO`,
    name: "Video",
    title: "Video",
    label: "",
    type: "",
    showChaptersToggle: "",
    edit: false,
    src: null,
    srcID: null,
    control: true,
    modal: false,
    autoplay: false,
    chapters: false,
    style: {
      maxWidth: "400",
    },
  },
  {
    data: `TABLE`,
    name: "Table",
    title: "Table",
    label: "",
    isMirrored: true,
    edit: false,
    desktopStyle: {
      justifyContent: "flex-start",
      marginLeft: "0",
      marginRight: "auto",
      tableHeaderSticky: false,
      tableColumnSticky: false,
      fontFamily: "",
      marginTop: "0",
      marginBottom: "0",
      paddingLeft: "0",
      paddingRight: "0",
      width: "",
      height: "400",
      fullHeight: true,
      float: "left",
      content: `<table style="height: 400px; font-size: 12px; border-collapse: separate; border-spacing: 0px !important; background-color: rgb(255, 255, 255); border: 1px solid rgb(147, 155, 163); margin-left: 0; margin-right: auto;" border=".5px" width="100%" cellpadding="10px">
<tbody>
<tr style="height: 126.375px; background-color: rgb(69, 91, 115);">
<td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163);  height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115);word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
  <td style="width: 25%; border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 126.375px; padding: 10px; background-color: rgb(69, 91, 115); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 1px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.9531px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 1px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
</tbody>
</table>`,
    },
    mobileStyle: {
      justifyContent: "flex-start",
      marginLeft: "0",
      marginRight: "auto",
      tableHeaderSticky: false,
      tableColumnSticky: false,
      fontFamily: "",
      width: "",
      height: "350",
      fullHeight: true,
      marginTop: "0",
      marginBottom: "0",
      paddingLeft: "0",
      paddingRight: "0",
      float: "left",
      content: `<table style="font-size: 12px; border-collapse: separate; border-spacing: 0px; background-color: rgb(255, 255, 255); border: 0.5px solid rgb(147, 155, 163); height: 398px; width: 100%; margin-left: 0; margin-right: auto;" border=".5px" width="100%" cellpadding="10px">
<tbody>
<tr style="background-color: rgb(69, 91, 115); height: 126.375px;">
<td style="width: 25%; border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); background-color: rgb(69, 91, 115); height: 126.375px; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="height: 126.375px; border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; background-color: rgb(69, 91, 115); width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; background-color: rgb(69, 91, 115); width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; width: 25%; background-color: rgb(69, 91, 115); height: 126.375px; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.8906px;">
<td style="width: 25%; border-width: 0.5px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.8906px;">
<td style="width: 25%; border-width: 0.5px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.8906px;">
<td style="width: 25%; border-width: 0.5px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.8906px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.8906px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
<tr style="background-color: rgb(255, 255, 255); height: 67.9531px;">
<td style="width: 25%; border-width: 0.5px; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; text-align: left; height: 67.9531px; padding: 10px; background-color: rgb(255, 255, 255); word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
<td style="border-width: 0.5px; text-align: center; vertical-align: middle; border-color: rgb(147, 155, 163); line-height: 1; height: 67.9531px; width: 25%; padding: 10px; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word; white-space: normal;">&nbsp;</td>
</tr>
</tbody>
</table>`,
    },
  },
  {
    data: `HTML`,
    title: "HTML",
    name: "HTML",
    label: "",
    content: "",
    edit: false,
    style: {
      fontFamily: "",
    },
  },
  {
    data: `TIMER`,
    name: "Timer",
    title: "Timer",
    label: "",
    date: new Date(),
    size: "smaller",
    patternStyle: "whiteRound--timer",
    style: {
      marginTop: "15",
      marginRight: "15",
      marginBottom: "15",
      marginLeft: "15",
      margin: "15",
      float: "left",
    },
  },
  {
    data: `FILE`,
    name: "File",
    title: "File",
    label: "",
    addFile: false,
    thumbID: null,
    thumb: null,
    files: [],
    href: "",
    style: {
      maxWidth: "400",
      height: "auto",
      opacity: "1",
      borderRadius: "0",
      float: "none",
    },
  },
  {
    data: `Line`,
    name: "Line",
    title: "Divider",
    label: "",
    style: {
      display: "block",
      marginTop: "15",
      marginRight: "0",
      marginBottom: "15",
      marginLeft: "0",
      borderWidth: "5",
      borderColor: "transparent",
      backgroundColor: { r: 255, g: 255, b: 255, a: 0 },
      borderStyle: "solid",
      width: "100%",
    },
  },
];
